import { Box, Heading } from '@wix/design-system';
import * as React from 'react';
import { useCallback, useEffect } from 'react';
import { SearchBox, VisibilityDetector } from '@wix/app-market-components';
import {
  useEssentials,
  AppMarketPage,
  useSearch,
  useTranslation,
  useSiteContext,
} from '@wix/app-market-core';
import { useSearchBoxActions } from '../../../components/search-box/hooks/search-box-actions';
import s from './header.scss';

const fillRowStyle = { width: '100%' };

export function HomePageHeader() {
  const { experiments } = useEssentials();
  const { languageCode, horizontalNav, headerSearch } = useSiteContext();
  const { t } = useTranslation();
  const { onSelect, onChange, onFocus, onEnterPressed } = useSearchBoxActions(
    AppMarketPage.HOMEPAGE,
    'search-bar-homepage',
  );
  const harmonyBorderEnabled = experiments.enabled('bmHarmonyTheme');
  const { setIsSearchShown } = useSearch();
  const onSearchVisible = useCallback(
    () => setIsSearchShown(false),
    [setIsSearchShown],
  );
  const onSearchHidden = useCallback(
    () => setIsSearchShown(true),
    [setIsSearchShown],
  );

  useEffect(() => {
    return () => setIsSearchShown(false);
  }, [setIsSearchShown]);

  const searchBox = (
    <SearchBox
      dataHook="search-box-home-page"
      onChange={onChange}
      onSelect={onSelect}
      onEnterPressed={onEnterPressed}
      onFocus={onFocus}
      languageCode={languageCode}
      experiments={experiments}
      size="large"
      border={harmonyBorderEnabled ? 'standard' : undefined}
      backgroundColor="var(--wds-input-background-fill-on-stage)"
    />
  );

  return (
    <Box
      className={`${s.headerContainer} ${
        horizontalNav ? s.horizontalNavHeaderContainer : ''
      }`}
      align="space-between"
    >
      <Box className={s.header} direction="vertical" gap="6px" maxWidth="718px">
        <Box marginTop={horizontalNav ? undefined : '18px'}>
          <Heading as="h1" size="large" dataHook="page-title">
            {t('home.page.title')}
          </Heading>
        </Box>
        <Box marginTop="12px">
          {headerSearch ? (
            <VisibilityDetector
              style={fillRowStyle}
              onVisible={onSearchVisible}
              onHidden={onSearchHidden}
            >
              <Box width="100%">{searchBox}</Box>
            </VisibilityDetector>
          ) : (
            searchBox
          )}
        </Box>
      </Box>
    </Box>
  );
}
